import { fbDB } from "../config/firebase";
import { QUIZ2_DATA_WATCH, QUIZ2_DATA_UPDATE, QUIZ2_META_WATCH } from "./types";

export const quiz2DataWatch = () => async dispatch => {
  fbDB.ref(`/activities/quizzes/data/quiz2`).on("value", snapshot => {
    return dispatch({
      type: QUIZ2_DATA_WATCH,
      payload: {
        data: snapshot.val()
      }
    });
  });
};

export const quiz2DataUpdate = (idx, data) => async dispatch => {
  fbDB
    .ref(`/activities/quizzes/data/quiz2/${idx}`)
    .update({
      ...data
    })
    .then(() => {
      return dispatch({
        type: QUIZ2_DATA_UPDATE,
        payload: null
      });
    })
    .catch(err => {
      console.log(err);
    });
};

export const quiz2MetaWatch = () => async dispatch => {
  fbDB.ref(`/activities/quizzes/meta/quiz2`).on("value", snapshot => {
    return dispatch({
      type: QUIZ2_META_WATCH,
      payload: {
        meta: snapshot.val()
      }
    });
  });
};
